import { render, staticRenderFns } from "./ScreenBoxClick.vue?vue&type=template&id=80df01da&scoped=true&"
import script from "./ScreenBoxClick.vue?vue&type=script&lang=js&"
export * from "./ScreenBoxClick.vue?vue&type=script&lang=js&"
import style0 from "./ScreenBoxClick.vue?vue&type=style&index=0&id=80df01da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80df01da",
  null
  
)

export default component.exports